import moment from "moment";

export const renderSidebar = (sideBarLinks, user) => {
  let tempSidebar = sideBarLinks.filter(
    ({ key }) =>
      user?.privileges.includes(key) || key === "" || key === user.type
  );
  return tempSidebar;
};
export const getTimeLeft = (expirationTime) => {
  const futureDate = moment(expirationTime);
  const currentTime = moment();
  const duration = moment.duration(futureDate.diff(currentTime));

  const daysLeft = Math.floor(duration.asDays());
  const hoursLeft = Math.floor(duration.asHours());
  const minutesLeft = Math.floor(duration.asMinutes());
  const secondsLeft = Math.floor(duration.asSeconds());

  if (secondsLeft <= 0) {
    return "Expired";
  } else if (daysLeft > 0) {
    return `${daysLeft} days left`;
  } else if (hoursLeft > 0) {
    return `${hoursLeft} hours left`;
  } else if (minutesLeft > 0) {
    return `${minutesLeft} minutes left`;
  } else {
    return `${secondsLeft} seconds left`;
  }
};
// export const numberWithCommas = (number) => {
//   return new Intl.NumberFormat("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   }).format(number);
// };
export const numberWithCommas = (number) => {
  const formattedNumber = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(number);

  return formattedNumber.replace(/\.00$/, "");
};
export const getOriginalAmount = (paidAmount, gstRate) => {
  const getOriginalAmount = paidAmount / (1 + gstRate / 100);
  return getOriginalAmount;
};
export const gstAmount = (paidAmount, gstRate) => {
  const originalGstAmount = ((paidAmount / 118) * gstRate).toFixed(2);
  return originalGstAmount;
};

export const getQueryString = (params) => {
  return new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(
        ([, value]) => value !== "" && value !== undefined && value !== null
      )
    )
  ).toString();
};
